module.exports = __webpack_public_path__ + "static/media/character7945fce4f62c2772b247c8f9baecf812.webp";